import logo from './logo.svg';
import './App.css';

// https://www.youtube.com/watch?v=WbV3zRgpw_E&t=6960s
import React, { useState }  from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/_navbar/Navbar'
import Footer from './components/_footer/Footer';
import HomeScreen from './components/home/HomeScreen';
import AboutUsScreen from './components/aboutus/AboutUsScreen';
import CodingTrainingScreen from './components/codingtraining/CodingTrainingScreen';
import PascoScreen from './components/pasco/PascoScreen';

function App() {
  return (
    <Router basename="/">
    <Navbar/>
      <div className="container">
        <Routes>
          <Route path="/" element={<HomeScreen/>} />
          <Route path="/aboutus" element={<AboutUsScreen/>} />
          <Route path="/pasco" element={<PascoScreen/>} />
          <Route path="/codingtraining" element={<CodingTrainingScreen/>} />
        </Routes>
        <Footer/>
      </div>
  </Router>
  );
}

export default App;
